/**
 *   Generated file. Do not edit
 */

import { AvailablePowerSource } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getManufacturer: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/manufacturer',
    path: '/3//0',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  getFirmwareFlavor: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/firmware-flavor',
    path: '/3//1',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  getSerialNumber: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/serial-number',
    path: '/3//2',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  getFirmwareVersion: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/firmware-version',
    path: '/3//3',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  reboot: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/device/reboot',
    path: '/3//4',
  } as ServiceCallType<void, void>,

  factoryReset: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/device/factory-reset',
    path: '/3//5',
  } as ServiceCallType<void, void>,

  getAvailablePowerSource: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/available-power-source',
    path: '/3//6',
    responseBodyDecoder: allConverters.availablePowerSource,
  } as ServiceCallType<void, AvailablePowerSource>,

  getPowerSourceVoltage: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/power-source-voltage',
    path: '/3//7',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  getMemoryFree: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/memory-free',
    path: '/3//10',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  getLastErrorCode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/last-error-code',
    path: '/3//11',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  postLastErrorCode: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/device/last-error-code',
    path: '/3//11',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,

  resetLastErrorCode: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/device/reset-last-error-code',
    path: '/3//12',
  } as ServiceCallType<void, void>,

  getCurrentTime: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/current-time',
    path: '/3//13',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  putCurrentTime: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/device/current-time',
    path: '/3//13',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,

  getInternalStatus: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/device/internal-status',
    path: '/3//15',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,
};
